<template>

<com-content class="write">

    <app-text>

        <app-group :bordered="true">

            <app-input-rating :expand="true" :label="page.reviews_write_rating_label" v-model="inputs.rating" :errored="errored.rating" />

            <div class="write-facilities" v-if="$_.keys(facilities).length">

                <div v-for="(facility, key) in facilities" :key="key" class="write-facilities-item">

                    <app-input-rating :slim="true" :small="true" :label="facility" v-model="inputs['facility_' + key]" :errored="errored.facility" />
                
                </div>

            </div>

            <app-input-date :label="page.reviews_write_date_label" v-model="inputs.date" :errored="errored.date" :placeholder="page.reviews_write_date_placeholder" />
            <app-input-time :label="page.reviews_write_time_label" v-model="inputs.time" :errored="errored.time" :placeholder="page.reviews_write_time_placeholder" />
            <app-input-text :multiline="true" :label="page.reviews_write_text_label" v-model="inputs.text" :errored="errored.text" :placeholder="page.reviews_write_text_placeholder" />
			<app-input-images :label="page.reviews_write_images_label" v-model="inputs.images" :errored="errored.images" />
            <app-input-toggle :expand="true" :label="page.reviews_write_recommend_label" v-model="inputs.recommend" :errored="errored.recommend" :options="recommend" />
            <app-input-toggle :expand="true" :label="page.reviews_write_contact_label" v-model="inputs.contact" :errored="errored.contact" :options="contact" />

        </app-group>

        <app-group :row="true" :center="true" v-if="loggedin">

            <app-button :fixed="true" :success="is.saved" :fail="is.errored" :text="page.reviews_write_button_save" :disabled="!is.valid" :loading="is.submitting" v-on:click="onSaveClick" />
            <app-button :to="toCancel" :fixed="true" theme="plain" :text="page.reviews_write_button_cancel" :disabled="is.submitting" />

        </app-group>

    </app-text>

    <app-text v-if="!loggedin" :center="true" class="write-authorise">

        <app-group>

            <h2>{{ page.reviews_write_authorise }}</h2>
                
            <app-button to="Login/Customer" :query="{redirect: $route.path}" :fixed="true" theme="blue" :text="page.reviews_write_button_login" />
            <app-button to="Register/Customer" :query="{redirect: $route.path}" :fixed="true" theme="plain" :text="page.reviews_write_button_register" />

        </app-group>

    </app-text>

</com-content>

</template>

<script>

import mixinForm from '@/mixin/form.js'
import Vue from 'vue'

import comContent from './../common/Content'

export default {

    mixins: [mixinForm],

    components: {
        'com-content': comContent
    },
    
	data: function() {

		return {
            recommend: {1: 'Yes', 2: 'No'},
            contact: {1: 'Both', 2: 'Phone', 3: 'Email'},
			inputs: {
                rating: 0,
                date: 0,
                time: 0,
				text: '',
				images: [],
                recommend: 0,
                contact: 0
            },
            is: {
                created: false
            },
			rules: {
				rating: {
                    required: true
                },
				date: {
                    required: true
                },
				text: {
                    required: true
                },
				recommend: {
                    required: true
                },
				contact: {
                    required: true
                }
			}
		}

    },

    computed: {

		facilities: function() {

			var facilities = {}

			this.$_.each(this.data.facilities, function(name, key) {

				if (this.$_.contains(this.page.business.facilities, key)) {

					facilities[key] = name

				}

			}.bind(this))

			console.log(facilities)

			return facilities

		},

        toCancel: function() {

            return (this.$route.query.cancel) ? {path: this.$route.query.cancel} : {name: 'Business/Reviews'}

        }

    },

    watch: {

        inputs: {

            deep: true,

            handler: function(n) {

                if (this.is.created) {

                    this.$store.commit('memory/add', {
                        name: 'review/' + this.page.business.slug,
                        value: n
                    })
                    
                }

                this.onInputsChange()

            }

        }

    },

    created: function() {

        this.$_.each(this.data.facilities, function(facility, key) {

            Vue.set(this.inputs, 'facility_' + key, 0)

        }.bind(this))

        this.is.created = true

        if (this.$store.getters['memory']['review/' + this.page.business.slug]) {

            this.inputs = this.$store.getters['memory']['review/' + this.page.business.slug]

		}

		document.title = [
			this.page.reviews_write_meta_title,
			this.page.business.name,
			this.settings.meta_suffix
		].join(' | ')

    },

    methods: {

		onSaveClick: function() {

            if (this.loggedin) {

                this.save('business/reviews/write', {
                    inputs: this.inputs,
                    slug: this.page.business.slug
                }).then(function(json) {

                    if (json.visible) this.page.business.reviews++

                    this.$store.commit('memory/delete', 'review/' + this.page.business.slug)

                    this.$router.push({
                        name: 'Business/Reviews'
                    })

                }.bind(this))
                
            }

		}

	}

}

</script>

<style scoped>

.write {
    padding-top: 0px!important;
}

.write-facilities {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-top: 10px;
    width: calc(100% + 40px);
    margin-left: -20px;
    margin-bottom: 15px;
    padding: 20px 20px 10px 20px;
    border-top: 1px solid var(--color-grey-light);
    border-bottom: 1px solid var(--color-grey-light);
}

.write-facilities-item {
	margin-right: 20px;
	margin-bottom: 10px;
}

.write-authorise {
    max-width: 480px!important;
    margin: 0px auto;
    margin-top: 40px;
}

.write-authorise >>> .button {
    width: auto;
    margin: 0px auto;
}

</style>